<template>
  <div id="app">

    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
    #app {
    margin-top: 0px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue